import cn from 'classnames'
import type { Prettify } from 'common/types'
import type { PropsWithChildren } from 'react'
import { forwardRef } from 'react'

import type { ClassNameProp } from '../../../types'
import { LayoutContextProvider, useLayoutContext } from '../context'
import type { ShowMode } from '../Footer'
import css from './Layout.css'

type LayoutProps = Prettify<
  ClassNameProp & {
    initialFooterState?: ShowMode
    noFullMode?: boolean
  }
>

const LayoutImpl = forwardRef<HTMLElement, PropsWithChildren<ClassNameProp>>(function Layout(
  { children, className, ...rest },
  ref,
) {
  const {
    footerApi: { showMode },
  } = useLayoutContext()

  const classNameFinal = cn(css.layout, className, {
    [css.showModeFull]: showMode === 'full',
    [css.showModeHalf]: showMode === 'half',
    [css.showModeNone]: showMode === 'none',
  })

  return (
    <main ref={ref} className={classNameFinal} data-show-mode={showMode} {...rest}>
      {children}
    </main>
  )
})

export const Layout = forwardRef<HTMLElement, PropsWithChildren<LayoutProps>>(function Layout(
  { children, className, initialFooterState, noFullMode, ...rest },
  ref,
) {
  return (
    <LayoutContextProvider initialFooterState={initialFooterState} noFullMode={noFullMode}>
      <LayoutImpl ref={ref} className={className} {...rest}>
        {children}
      </LayoutImpl>
    </LayoutContextProvider>
  )
})
